import type { RouterContextType } from "@/api/permissions/permissions.api";
import { CreateEntityForm } from "@/components/features/CreateEntityForm/CreateEntityForm";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/entities/create-entity/")({
  component: CreateEntity,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function CreateEntity() {
  return <CreateEntityForm />;
}
